import React from 'react';
import cx from 'classnames';
import { Text } from '../../../atoms';
import styles from './ModalHeader.module.scss';
import type { ModalHeaderProps } from './ModalHeader.types';
import useBuildVariantProps from '../../../../modules/theme/useBuildVariantProps';

/**
 * Modal Header component definition.
 */
const ModalHeader = (props: ModalHeaderProps) => {
  const {
    className,
    title,
    iconButton,
    ...restProps
  } = props;

  let titleComponent, iconButtonComponent;

  // Render icon button if passed
  if (iconButton) {
    iconButtonComponent = (
      <>
        {iconButton}
      </>
    )
  }

  const variantProps = useBuildVariantProps('modal-header', {}, {});

  return (
    <div className={cx(styles.modalHeader, className)} {...variantProps} {...restProps}>
      <Text
        className={styles.title}
        weight="Medium"
        type="BodyMedium"
      >
        {title}
      </Text>
      {iconButtonComponent}
    </div>
  );
};

export default ModalHeader;
